import React from "react";
import "./styles.scss";
import TrendingItem from "./TrendingItem";
import _ from "lodash";
import FullPageSpinner from "./../../FullPageSpinner";
import { indexTrending } from "../../../api/discover";
import { Link } from "react-router-dom";

export default class Trending extends React.Component {
  state = { trending: null };
  componentDidMount = async () => {
    let {
      data: { trending }
    } = await indexTrending();
    this.setState({ trending });
  };
  render() {
    return _.isNull(this.state.trending) ? (
      <FullPageSpinner />
    ) : this.state.trending.trending_post ||
      this.state.trending.trending_sound_track ? (
      <div id="trending" className="m-4 my-5">
        <h2 className="mb-3">Trending</h2>
        {this.state.trending.trending_post && (
          <Link to={`/post/${this.state.trending.trending_post.id}`}>
            <TrendingItem item={this.state.trending.trending_post} />
          </Link>
        )}
        {this.state.trending.trending_sound_track && (
          <Link
            to={`/sound_track/${this.state.trending.trending_sound_track.id}`}
          >
            <TrendingItem item={this.state.trending.trending_sound_track} />
          </Link>
        )}
      </div>
    ) : null;
  }
}
